// A simpler version inspired by $.numberFormat
export const numberFormat = (number, decimals, decimalSeparator, thousandsSeparator) => {
  number = number.toFixed(decimals)
  let nstr = number.toString()
  nstr += ''
  let x = nstr.split('.')
  let x1 = x[0]
  let x2 = x.length > 1 ? decimalSeparator + x[1] : ''
  let rgx = /(\d+)(\d{3})/
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + thousandsSeparator + '$2')
  }
  return x1 + x2
}

export const formatPriceWithLocalizedCurrency = (price, locale, currency) => {
  return Intl.NumberFormat(
    locale, { style: 'currency', currency: currency, minimumFractionDigits: 0 }
  ).format(price).replace(',', '.')
}

const _isNumerical = object => {
  object = object - 0
  return object
}

export const camelize = (string) => {
  if (_isNumerical(string)) {
    return string
  }
  string = string.replace(/[\-_\s]+(.)?/g, function(match, character) {
    return character ? character.toUpperCase() : ''
  })
  // 1st char is always lowercase
  return string.substr(0, 1).toLowerCase() + string.substr(1)
}
